document.addEventListener("DOMContentLoaded", () => {
    console.log("Modal quote");
});